import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { Dispatch, SetStateAction, useState } from "react";
import Modal from "react-modal";
import { Animal } from "../../contexts/Staking/types";
import useWindowSize from "../../hooks/useWindowSize";
import { Button } from "../Button";
import { ButtonWrapper, CloseButton, Content, DismissWrapper, InfoWrapper, ModalTitle, NftImage, Warning } from "./styles";

interface ModalProps {
  modalIsOpen: boolean,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  token: Animal,
  callback: () => void,
  title: string,
  description: string,
  id: string,
}


const CustomModal = ({ modalIsOpen, setIsOpen, token, callback, title, description, id }: ModalProps ) => {
  const { isTabPort } = useWindowSize();

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "black",
      border: "none",
      color: "white",
      padding: "0",
      zIndex: "101",
      borderRadius: "20px",
      maxWidth: isTabPort ? "600px" : "",
      maxHeight: "100vh",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: "100",
    },
  };

  if (modalIsOpen) window.document.body.classList.add("no-scroll");

  const handleCloseModal = () => {
    window.document.body.classList.remove("no-scroll");
    setIsOpen(false);
  };

  const handlePositiveResponse = () => {
    callback();
    handleCloseModal();
  }

  const handleCheckboxClicked = (e: CheckboxChangeEvent) => {
    localStorage.setItem(id, e.target.checked.toString());
  }

    return (
      <Modal
      isOpen={modalIsOpen}
      onRequestClose={handleCloseModal}
      contentLabel="NFT Detail Modal"
      style={customModalStyles}
      ariaHideApp={false}
    >
      <CloseButton onClick={handleCloseModal}>
        <FontAwesomeIcon color="white" size="lg" icon="times" />
      </CloseButton>
      <Content>
        <NftImage src={token.uriData.image} />
        <InfoWrapper>
          <ModalTitle>{title}</ModalTitle>
          <Warning>{description}</Warning>
          <DismissWrapper>
            <label>Do not show me this message again</label>
            <Checkbox name={id} onChange={handleCheckboxClicked} />
          </DismissWrapper>
          <ButtonWrapper>
            <Button onClick={handlePositiveResponse} color={"primary"}>CONFIRM</Button>
            <Button onClick={handleCloseModal}>Cancel</Button>
          </ButtonWrapper>
        </InfoWrapper>
      </Content>
      </Modal>
    )
}

export default CustomModal;